import { render, staticRenderFns } from "./inviteInfo.vue?vue&type=template&id=61f208b8&scoped=true"
import script from "./inviteInfo.vue?vue&type=script&lang=js"
export * from "./inviteInfo.vue?vue&type=script&lang=js"
import style0 from "./inviteInfo.vue?vue&type=style&index=0&id=61f208b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f208b8",
  null
  
)

export default component.exports